class Spinner extends React.Component {
  constructor(props) {
    super(props);

    this.timeout = null;

    this.state = {
      spins: 0,
      message: undefined
    };
  }

  spin(n = 1, message) {
    let spins = this.state.spins + n;

    if (spins < 0 || n === 0) {
      spins = 0;
    }

    if (n > 0) {
      this.setState({ message });
    }

    if (spins > 0) {
      this.setState({ spins });
    }
    else {
      clearTimeout(this.timeout);

      this.timeout = setTimeout((function () {
        this.setState({ spins });
      }).bind(this), 350);
    }
  }

  render() {
    let { spins, message } = this.state;

    return (
      <div className="mc-spinner" aria-hidden={spins <= 0}>
        {message || tx("loading")}
      </div>
    );
  }
}

module.exports = Spinner;